import { EM_DASH } from "./constants"
import type { DateTimeDisplay, Locale } from "./types"

type Options = {
  display?: DateTimeDisplay
} & Intl.DateTimeFormatOptions

export const dateTimeFormatter =
  (locale: Locale = "en-US") =>
  (
    date: Date | null | undefined,
    { display = "date", ...rest }: Options = {},
  ) => {
    if (!date) {
      return EM_DASH
    }

    if (display === "custom") {
      return Intl.DateTimeFormat(locale, rest).format(date)
    }

    if (display === "date") {
      return Intl.DateTimeFormat(locale, {
        year: "numeric",
        month: "short",
        day: "numeric",
        ...rest,
      }).format(date)
    }

    if (display === "date-numeric") {
      return Intl.DateTimeFormat(locale, {
        year: "2-digit",
        month: "numeric",
        day: "numeric",
        ...rest,
      }).format(date)
    }

    if (display === "datetime") {
      return Intl.DateTimeFormat(locale, {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
        ...rest,
      }).format(date)
    }

    if (display === "datetime-numeric") {
      return Intl.DateTimeFormat(locale, {
        month: "numeric",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
        ...rest,
      }).format(date)
    }

    return Intl.DateTimeFormat(locale, rest).format(date)
  }
